import { ApiService } from "src/network/apiService";
import {
	INewApplicationModel,
	IBusinessListModel,
	IContactCentreModel,
	IMobileAppModel,
} from "src/types/models/apiModels";

export class NewApplicationViewModel {
	private apiService: ApiService;

	constructor(accessToken: string) {
		this.apiService = new ApiService({ accessToken: accessToken });
	}

	// async validateApplication(
	// 	application: INewApplicationModel
	// ): Promise<string[]> {
	// 	const errors: string[] = [];
	// 	if (!application.brandingOption) {
	// 		errors.push("brandingOption is required");
	// 	}
	// 	if (!application.businessId) {
	// 		errors.push("businessId is required");
	// 	}
	// 	if (!application.brandingAppCode) {
	// 		errors.push("brandingApplicationId required");
	// 	}
	// 	return errors;
	// }

	async submitApplication(
		application: INewApplicationModel
	): Promise<{ result: boolean; error?: string }> {
		// console.log(`request to create a new branding application ${JSON.stringify(application)}`)
		// console.log("request to create a new branding application", application);

		try {
			const response: any = await this.apiService.postAsync(
				"/onboard/application",
				application
			);
			if (response) {
				if (response.scResponse && response.scResponse.code === 2000) {
					return { result: true };
				} else {
					return {
						result: false,
						error: response.scResponse?.message,
					};
				}
			}
		} catch (error) {
			return {
				result: false,
				error: "There was an error performing the operation",
			};
		}

		return {
			result: true,
			error: "There was an error performing the operation",
		};
	}

	async fetchBusinessList(): Promise<IBusinessListModel[]> {
		const response = await this.apiService.getAsync<any>(
			"/onboard/businesses"
		);

		if (response) {
			if (response.scResponse && response.scResponse.code === 2000) {
				return response.scResponse.data;
			}

			return [];
		}

		return [];
	}

	async fetchContactCentreList(): Promise<IContactCentreModel[]> {
		const response = await this.apiService.getAsync<any>(
			"/onboard/contact-centres"
		);

		if (response) {
			if (response.scResponse && response.scResponse.code === 2000) {
				return response.scResponse.data;
			}

			return [];
		}

		return [];
	}
	async fetchMobileAppList(): Promise<IMobileAppModel[]> {
		const response = await this.apiService.getAsync<any>(
			"/onboard/branding-apps"
		);

		if (response) {
			if (response.scResponse && response.scResponse.code === 2000) {
				return response.scResponse.data;
			}

			return [];
		}

		return [];
	}
}
